import * as Yup from 'yup';
import i18n from '../../services/i18n';
import { Colors } from "../../styles/Colors";
import { makeStyles } from '@material-ui/core';
import { PhonebookRecord } from "../../store/actions/accountPhoneBook/payloads";

export type NewAccountPhoneBookContactDialogProps = {
    isOpen: boolean;
    clickOnClose?: (reload: boolean) => void;
    editRecord?: PhonebookRecord;
};

const requiredError = i18n.t<string>('errors:common.emptyInput');
export const addDevicePhoneBookValidationSchema = Yup.object().shape({
    dial_id: Yup.string()
        .matches(/^[0-9#*]+$/, i18n.t('errors:common.wrongFormat'))
        .notRequired(),
    phone_number: Yup.string()
        .matches(/^\+?[0-9A-Da-d#*]+$/, i18n.t('errors:common.wrongFormat'))
        .required(requiredError),
    name: Yup.string()
        .notRequired(),
    phone_type: Yup.string()
        .required(requiredError),
});

export const useStyles = makeStyles(() => ({
    error: {
        color: Colors.Error,
        fontSize: 12,
        fontWeight: 400,

        '& svg': {
            display: 'none',
        },
    },

    itemsContainer: {
        padding: '41px 48px 33px 48px',
        display: 'flex',
        flexDirection: 'column',
        width: 472,

        '& p': {
            fontWeight: 700,
            fontSize: 16,
            lineHeight: '20px',
        },

        '& .MuiFormControl-root': {
            width: 472,
            marginBottom: 24,
        },
    },

    form: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        flexGrow: 1,
        width: 568,
        padding: 0,
        margin: 0,
        overflowX: 'hidden'
    },

    modalContainer: {
        '& .MuiDialogContent-root': {
            background: Colors.SmokeBackground,
            width: 568,
            height: 'fit-content',
            padding: 0,
            margin: 0,
        },

        '& .MuiDialog-paperWidthSm': {
            maxWidth: 'unset',
            maxHeight: 'unset'
        },

        '& .MuiGrid-root:first-child': {
            marginTop: 0,
        },

        '& .MuiPaper-root': {
            width: 568,
        },
        
        '& .MuiFormHelperText-root': {
            right: 0,
            fontSize: '0.75rem',
            fontWeight: 400
        },
    },
    header: {
        '& .MuiTypography-h6': {
            fontWeight: 700,
            fontSize: 18,
        },
    },

    boxRow: {
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
        width: 472,

        '& .Mui-error': {
            fontWeight: 400,
        },
    },

    initMac: {
        '& .MuiInputBase-input.MuiInput-input': {
            color: Colors.LightGraySecondary3,
        },
    },

    favoriteNumber: {
        marginBottom: 0,
        height: 'unset'
    }
}));
